import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSmallChevron = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 7,
	height: 4.66,
	viewBox: "-0.001 0 6.395 4.258",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.86328 3.72729L3.19661 1.06063L0.529948 3.72729",
		stroke: "currentColor",
		strokeWidth: 1.5
	})
});
export { SvgSmallChevron as ReactComponent };
